<template>
  <AppDialog scroll-body v-model:open="open" :title="t('nkf.promptDetails.medicine')">
    <template #illustration>
      <AppDialogIllustration src="/images/nkf/pill.webp" background="var(--card)" width="78%" />
    </template>
    <div class="tw:text-center tw:grid tw:gap-2">
      <p class="tw:type-body-strong">
        {{ notification.snapshot.medication.name }}
        <template v-if="notification.snapshot.medication.dose">
          · {{ notification.snapshot.medication.dose }}
        </template>
      </p>
      <p class="tw:type-body tw:text-muted-foreground">
        {{
          t('nkf.promptDetails.scheduled', {
            time: DateUtils.formatServerDayTime(notification.eventTimeRaw),
          })
        }}
      </p>
      <img
        v-if="notification.snapshot.medication.image"
        :src="notification.snapshot.medication.image"
        :alt="notification.snapshot.medication.name"
        class="tw:size-24 tw:object-contain tw:mx-auto"
      />
    </div>
    <AppDialogNote
      v-if="notification.snapshot.medication.note"
      icon="info"
      tone="info"
      class="tw:whitespace-pre-wrap"
    >
      {{ notification.snapshot.medication.note }}
    </AppDialogNote>
    <template #secondary-actions>
      <Button
        v-if="notification.allowedActions.includes(MEDICATION_NOTIFICATION_ACTION.SKIPPED)"
        variant="outline"
        :disabled="saving"
        @click="emit('respond', MEDICATION_NOTIFICATION_ACTION.SKIPPED)"
        >{{ t('nkf.interactions.skipDose') }}</Button
      >
      <Button
        v-if="notification.allowedActions.includes(MEDICATION_NOTIFICATION_ACTION.SNOOZED)"
        variant="outline"
        :disabled="saving"
        @click="emit('respond', MEDICATION_NOTIFICATION_ACTION.SNOOZED)"
        ><AppIcon name="clock" size="action" />{{
          t('nkf.interactions.snooze', { count: notification.snoozeMinutes })
        }}</Button
      >
    </template>
    <template #footer>
      <Button
        v-if="notification.allowedActions.includes(MEDICATION_NOTIFICATION_ACTION.TAKEN)"
        :disabled="saving"
        @click="emit('respond', MEDICATION_NOTIFICATION_ACTION.TAKEN)"
        ><AppIcon name="check" size="action" />{{ t('nkf.interactions.tookDose') }}</Button
      >
    </template>
  </AppDialog>
</template>

<script setup>
// 1. Import necessary components
import DateUtils from '@/shared/utilities/date-utils';
import { useI18n } from 'vue-i18n';
import { MEDICATION_NOTIFICATION_ACTION } from '../constants/notification';
import AppIcon from '@/shared/components/AppIcon.vue';
import AppDialog from '@/shared/components/AppDialog.vue';
import AppDialogIllustration from '@/shared/components/AppDialogIllustration.vue';
import AppDialogNote from '@/shared/components/AppDialogNote.vue';
import { Button } from '@/shared/components/ui/button';

// 2. Use
const open = defineModel('open', { type: Boolean, default: false });
defineProps({
  notification: { type: Object, required: true },
  saving: { type: Boolean, default: false },
});
const emit = defineEmits(['respond']);
const { t } = useI18n();

// 3. Define a reactive variable
// 4. Define methods or computed properties if needed
// 5. VueJS Hooks
</script>
